
import React, { useState, useEffect, useMemo } from 'react';
import { Button, Checkbox, Input } from './StandardComponents';
import './survey.css';
import { Sticky } from './StandardComponents';

// "use client"; // ← required if you’re in Next.js App Router


// export function TallyEmbed({
//   formId,                 // e.g. "w5gkXo"
//   hidden = {},            // { userId: "123", plan: "pro" }
//   style,
//   onSubmit,
//   allowedOrigins = ["https://tally.so", "https://www.tally.so"],
//   className,
//   height = "600px",
// }) {
//   const search = new URLSearchParams({
//     ...hidden,
//     alignLeft: "1",
//     hideTitle: "1",
//     transparentBackground: "1",
//     dynamicHeight: "1",
//   }).toString();

//   // ✅ Use the EMBED route (not /r/)
//   const src = `https://tally.so/embed/${formId}${search ? `?${search}` : ""}`;

//   useEffect(() => {
//     // Load Tally’s helper (optional but nice for resizing)
//     const id = "tally-embed-js";
//     if (!document.getElementById(id)) {
//       const s = document.createElement("script");
//       s.id = id;
//       s.src = "https://tally.so/widgets/embed.js";
//       s.async = true;
//       s.onload = () => window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
//       document.head.appendChild(s);
//     } else {
//       window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
//     }

//     const handler = (e) => {
//       // Only accept messages from Tally
//       if (!allowedOrigins.includes(e.origin)) return;

//       let data = e.data;
//       if (typeof data === "string") {
//         try { data = JSON.parse(data); } catch { /* ignore non-JSON */ }
//       }
//       if (!data || !data.event) return;

//       if (data.event === "Tally.FormSubmitted") {
//         onSubmit && onSubmit(data.payload);
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, [onSubmit, allowedOrigins]);

//   useEffect(() => {
//   const logAll = (e) => {
//     if (!/https:\/\/(www\.)?tally\.so/.test(e.origin)) return;
//     console.log("[Tally msg]", e.origin, e.data);
//   };
//   window.addEventListener("message", logAll);
//   return () => window.removeEventListener("message", logAll);
// }, []);

//   return (
//     <iframe
//       src={src}
//       width="100%"
//       height={height}
//       style={{ border: 0, ...style }}
//       className={className}
//       title="Tally form"
//       loading="lazy"
//       // Don’t add a restrictive sandbox, it can block postMessage.
//       allow="fullscreen; clipboard-read; clipboard-write"
//     />
//   );
// }

// export function TallyEmbed({
//   formId,                 // e.g. "w5gkXo"
//   hidden = {},            // { userId: "123", plan: "pro" }
//   style,
//   onSubmit,
//   allowedOrigins = ["https://tally.so", "https://www.tally.so"],
//   className,
//   height = "600px",
// }) {
//   const search = new URLSearchParams(hidden).toString();
//   const src = `https://tally.so/r/${formId}${search ? `?${search}` : ""}`;

//  useEffect(() => {
//     // Load Tally’s script once
//     const id = "tally-embed-js";
//     if (!document.getElementById(id)) {
//       const s = document.createElement("script");
//       s.id = id;
//       s.src = "https://tally.so/widgets/embed.js";
//       s.async = true;
//       s.onload = () => window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
//       document.head.appendChild(s);
//     } else {
//       window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
//     }

//     const handler = (e) => {
//       // 1) Make sure it actually comes from Tally
//       if (!allowedOrigins.includes(e.origin)) return;

//       // 2) Some browsers send a stringified JSON; others an object.
//       let data = e.data;
//       if (typeof data === "string") {
//         try { data = JSON.parse(data); } catch (err) { return; }
//       }
//       if (!data || !data.event) return;

//       // 3) Fire your callback on submit
//       if (data.event === "Tally.FormSubmitted") {
//         onSubmit && onSubmit(data.payload);
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, [onSubmit, allowedOrigins]);

//   return (
//     <iframe
//       src={src}
//       width="100%"
//       height={height}
//       style={{ border: 0, ...style }}
//       className={className}
//       title="Tally form"
//       loading="lazy"
//       allow="fullscreen; clipboard-read; clipboard-write"
//     />
//   );
// }

// export function Page() {
//   return (
//     <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
//       <h1>Quick survey</h1>
//       <TallyEmbed
//         formId="w5gkXo"
//         hidden={{ userId: "123", email: "alice@example.com" }} // passes as hidden fields
//         height="75vh"
//       />
//     </div>
//   );
// }

// SurveyPage.jsx (React)
export const SurveyPage = () => {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <h1>Industry Feedback Survey</h1>
      <p>This quick 3-minute survey helps us assess cleanroom workflows.</p>

      <iframe
        src="https://tally.so/r/n9VYMK"
        title="Industry Feedback: Cleanroom-Compatible Wipe and Glove Survey"
        width="100%"
        height="80vh"
        style={{ border: 0, borderRadius: 12 }}
        loading="lazy"
        allow="fullscreen; clipboard-read; clipboard-write"
      />
    </main>
  );
}

// function TallyModal({ formId, hidden = {}, open, onClose }) {
//   if (!open) return null;
//   const params = new URLSearchParams(hidden).toString();
//   const src = `https://tally.so/r/${formId}`;
//   return (
//     <div style={{
//       position: "fixed", inset: 0, background: "rgba(0,0,0,.5)",
//       display: "grid", placeItems: "center", zIndex: 999999999
//     }}>
//       <div style={{ width: "min(100vw, 900px)", height: "80vh", background: "#fff", borderRadius: 12, overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,.3)" }}>
//         <div style={{ display: "flex", justifyContent: "flex-end", padding: 8 }}>
//           <button onClick={onClose} aria-label="Close">✕</button>
//         </div>
//         <iframe
//           src={src}
//           title="Tally form"
//           width="100%"
//           height="100%"
//           style={{ border: 0 }}
//           loading="lazy"
//           allow="fullscreen; clipboard-read; clipboard-write"
//         />
//       </div>
//     </div>
//   );
// }

// "use client"; // uncomment if you're on Next.js App Router

// "use client"; // if using Next.js App Router

// "use client"; // uncomment if using Next.js App Router


// "use client";

export default function TallyModal({
  formId,
  hidden = {},
  open,
  onClose,
  onSubmit,
  autoCloseOnSubmit = true,
  allowedOrigins = ["https://tally.so", "https://www.tally.so"],
  title = "Industry Feedback: Cleanroom-Compatible Wipe and Glove for Residual Hydrogen Peroxide Detection",
  subtitle,
  maxWidth = 900,
  edgePadding = 24,
  heightVh = 80,
}) {
  // Build EMBED url (note: NO dynamicHeight here; we want the iframe to scroll)
  const src = useMemo(() => {
    const params = new URLSearchParams({
      ...hidden,
      alignLeft: "1",
      hideTitle: "1",
      transparentBackground: "1",
      // dynamicHeight: "1", // ❌ remove for modal use
    }).toString();
    return `https://tally.so/embed/${formId}${params ? `?${params}` : ""}`;
  }, [formId, hidden]);

  // 1) Lock background scroll when modal is open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [open]);

  // 2) Load Tally helper + listen for submit
  useEffect(() => {
    if (!open) return;

    const id = "tally-embed-js";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = "https://tally.so/widgets/embed.js";
      s.async = true;
      s.onload = () => window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
      document.head.appendChild(s);
    } else {
      window.Tally && window.Tally.loadEmbeds && window.Tally.loadEmbeds();
    }

    const handler = (e) => {
      if (!allowedOrigins.includes(e.origin)) return;

      let data = e.data;
      if (typeof data === "string") {
        try { data = JSON.parse(data); } catch { return; }
      }
      if (!data || !data.event) return;

      if (data.event === "Tally.FormSubmitted") {
        try { onSubmit && onSubmit(data.payload); } catch {}
        if (autoCloseOnSubmit) onClose && onClose();
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [open, allowedOrigins, onSubmit, onClose, autoCloseOnSubmit]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="tally-modal-title"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.5)",
        display: "grid",
        placeItems: "center",
        padding: edgePadding,        // nice viewport margin
        zIndex: 999999999,
        overscrollBehavior: "none",  // keep outer page from rubber-banding
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth,
          height: `min(${heightVh}vh, 100%)`,
          background: "#fff",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,.3)",
          display: "grid",
          gridTemplateRows: "auto 1fr", // header + iframe area
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: "1px solid #eee",
            gap: 12,
          }}
        >
          <div style={{ minWidth: 0 }}>
            <h2 id="tally-modal-title" style={{ margin: 0, fontSize: "1.5em", lineHeight: 1.3, color: "#1a1a1a" }} title={title}>
              {title}
            </h2>
            {subtitle ? (
              <div
                style={{
                  marginTop: 2,
                  fontSize: 13,
                  color: "#666",
                  lineHeight: 1.3,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={subtitle}
              >
                {subtitle}
              </div>
            ) : null}
          </div>

          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              appearance: "none",
              border: "1px solid #ddd",
              background: "#fff",
              borderRadius: 8,
              padding: "6px 10px",
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Iframe: fills remaining space; it scrolls internally */}
        <iframe
          src={src}
          title="Tally form"
          width="100%"
          height="100%"
          style={{
            border: 0,
            display: "block",
            padding: "2em",
            // iOS niceties:
            WebkitOverflowScrolling: "touch",
          }}
          loading="lazy"
          allow="fullscreen; clipboard-read; clipboard-write"
        />
      </div>
    </div>
  );
}



export const NordlinkSurvey = () => {
  const [open, setOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  return (
    <>
    <Sticky
        offsetSticky={"8vh"}
        fadeSticky={true}
        className={"sticky-category-gallery-header"}
        //stickyCallback={stickyCallback}
    >
        {(isSticky) => (
            <div className={"category-gallery-header-c"}>
                <h1 className={"category-gallery-header"}>
                    {["Industry Survey"]}
                </h1>
                <span className={`category-gallery-subheader ${isSticky ? "fade-out" : "fade-in"}`}>
                    {/* {category.plSubtitle} */}
                </span>
            </div>
        )}
    </Sticky>
      <div className={'survey-container'} >

        <span className={'survey-title'}>
            {!isSubmitted ? 
              'Cleanroom-Compatible Wipe and Glove for Residual Hydrogen Peroxide Detection' :
              'Thank you for your time and insights'
            }
        </span>
        <br></br>
         <div className={'survey-container-inner'} >
            <span className={'survey-subtitle'}>
                {!isSubmitted ? 
              'This 3-minute survey explores current practices, risks, and potential value of a disposable wipe and over-glove for visual detection of residual hydrogen peroxide in cleanroom operations'
              : 
              ''
              }
            </span>

            {!isSubmitted ? 
            <Button 
            show={true}
            classTypes={["classical", "select"]}
            className={'survey-title'}
            theme={1}
            height={"fit-content"}
            width={"fit-content"}
            wrapperStyle={{marginLeft: "auto"}}
            parentCallback={() => setOpen(true)}>Open survey
            </Button>
            :
            <a href = "https://docs.google.com/spreadsheets/d/1ovdtfFfFFgjEO4T7NFFGHUxvhkziKumg5d37XD48ueo" class="card" target="_blank" rel="noopener">
            <Button 
            show={true}
            classTypes={["classical", "min"]}
            className={'survey-title'}
            theme={1}
               height={"fit-content"}
            width={"fit-content"}
            wrapperStyle={{marginLeft: "auto"}}
            parentCallback={() => {}}>Survey Summary
            </Button>
            </a>
            }
      </div>
      </div>

      <TallyModal
        formId="n9VYMK"
        hidden={{ userId: "123" }}
        open={open}
        onSubmit={(payload) => {
            setIsSubmitted(true)
            // alert("Thanks! We got your message.");   // ✅ runs after submit
    // e.g. window.location.assign("/thank-you");
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
